module.exports = __webpack_public_path__ + "img/art_secret_beach.8600477b.jpg";